import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { api } from "@/lib/api";
import { PRIORITY, fmtDate } from "@/lib/format";
import { Field, Sel, mapOpts } from "@/components/Field";
import { FormDialog, useSubmit, clean } from "./FormDialog";

const EMPTY = { title: "", description: "", assignees: [], due_date: "", priority: "normal", event_id: "" };

export const TaskDialog = ({ open, onOpenChange, task, preset, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  const [members, setMembers] = useState([]);
  const [events, setEvents] = useState([]);
  const { saving, run } = useSubmit();
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));

  useEffect(() => {
    if (!open) return;
    setF(task ? { ...EMPTY, ...Object.fromEntries(Object.keys(EMPTY).map((k) => [k, task[k] ?? (k === "assignees" ? [] : "")])) } : { ...EMPTY, ...(preset || {}) });
    api.get("/members").then((r) => setMembers(r.data.filter((m) => m.status === "active")));
    api.get("/events").then((r) => setEvents(r.data)).catch(() => setEvents([]));
  }, [open, task, preset]);

  const toggle = (uid) => setF((s) => ({ ...s, assignees: s.assignees.includes(uid) ? s.assignees.filter((x) => x !== uid) : [...s.assignees, uid] }));

  const submit = () =>
    run(async () => {
      if (!f.assignees.length) throw Object.assign(new Error(), { response: { data: { detail: "Scegli almeno un responsabile" } } });
      const body = clean(f);
      const { data } = task ? await api.patch(`/tasks/${task.id}`, body) : await api.post("/tasks", body);
      onOpenChange(false);
      onSaved?.(data);
    }, task ? "Compito aggiornato" : "Compito creato");

  return (
    <FormDialog open={open} onOpenChange={onOpenChange} title={task ? "Modifica compito" : "Crea compito"} onSubmit={submit} saving={saving} testId="task-dialog">
      <Field label="Titolo *"><Input data-testid="task-title-input" required value={f.title} onChange={set("title")} className="h-11" /></Field>
      <Field label="Descrizione"><Textarea data-testid="task-description-input" value={f.description} onChange={set("description")} rows={3} /></Field>
      <Field label="Responsabili *">
        <div data-testid="task-assignees" className="max-h-40 overflow-y-auto rounded-md border border-input divide-y">
          {members.map((m) => (
            <label key={m.user_id} className="flex items-center gap-3 px-3 min-h-[44px] cursor-pointer hover:bg-slate-50">
              <Checkbox data-testid={`task-assignee-${m.user_id}`} checked={f.assignees.includes(m.user_id)} onCheckedChange={() => toggle(m.user_id)} />
              <span className="text-[15px]">{m.name}</span>
            </label>
          ))}
        </div>
      </Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Scadenza"><Input data-testid="task-due-input" type="date" value={f.due_date} onChange={set("due_date")} className="h-11" /></Field>
        <Field label="Priorità"><Sel testId="task-priority-select" value={f.priority} onChange={set("priority")} options={mapOpts(PRIORITY)} /></Field>
      </div>
      {events.length > 0 && <Field label="Evento collegato"><Sel testId="task-event-select" value={f.event_id} onChange={set("event_id")} placeholder="Nessuno" options={events.map((e) => ({ value: e.id, label: `${e.name} (${fmtDate(e.start)})` }))} /></Field>}
    </FormDialog>
  );
};
